import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AdminLayout from '../Admin_Layout/AdminLayout';
import { useNavigate } from 'react-router-dom';

const UpdateNews = ({ role = 'admin' }) => {
  const [newsData, setNewsData] = useState([]);
  const [message, setMessage] = useState('No News Available');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNews = async () => {
      let userId = localStorage.getItem('userId');
      if (role === 'user' && !userId) return navigate('/login');

      const url =
        role === 'admin'
          ? `${process.env.REACT_APP_API_URL}/api/news`
          : `${process.env.REACT_APP_API_URL}/api/news/user/${userId}`;

      try {
        const response = await fetch(url);
        const data = await response.json();

        console.log(" Fetched News Data:", data);

        if (!response.ok) {
          console.error('Failed to fetch news:', data.message);
          setMessage(data.message || 'Failed to fetch news');
          return;
        }
        const sortedData = data.sort((a, b) => a.index - b.index); // ← oldest first (ascending)
        setNewsData(sortedData);
      } catch (error) {
        console.error('Error fetching news:', error);
        setMessage('Error fetching news');
      }

    };

    fetchNews();
  }, [navigate, role]);

  const handleEdit = (news) => {
    console.log('📝 Edit news clicked...');
    if (role === 'admin') {
      navigate('/admin-dashboard/manage-blogs/update-news/specific', {
        state: { update: true, formData: news }
      });
    } else {
      navigate('/user-dashboard/manage-blogs/update-news/specific', {
        state: { update: true, formData: news }
      });
    }
  };


  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this news post?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/news/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) throw new Error('Failed to delete the news post');

      setNewsData((prev) => prev.filter((item) => item._id !== id));
      alert('News deleted successfully!');
    } catch (error) {
      console.error('Error deleting news:', error);
      alert('Failed to delete the news. Please try again.');
    }
  };

  return (
    <AdminLayout role={role}>
      {newsData.length > 0 ? (
        <Box sx={{ p: 4 }}>
          <Container maxWidth="lg">
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
              <Typography variant="h4" gutterBottom sx={{ mt: 5 }}>
                News
              </Typography>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell><strong>Index</strong></TableCell>
                      <TableCell><strong>Title</strong></TableCell>
                      <TableCell><strong>Date</strong></TableCell>
                      <TableCell><strong>Field</strong></TableCell>
                      <TableCell><strong>Image</strong></TableCell>
                      <TableCell><strong>Actions</strong></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {newsData.map((news, index) => (
                      <TableRow key={index}>
                        <TableCell>{news.index}</TableCell>
                        <TableCell>{news.title}</TableCell>
                        <TableCell>
                          {new Date(news.date).toLocaleString('en-IN', {
                            day: '2-digit',
                            month: 'short',
                            year: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: true
                          })}
                        </TableCell>
                        <TableCell>{news.field}</TableCell>
                        <TableCell>
                          {news.imageURL ? (
                            <img
                              src={news.imageURL}
                              alt="news"
                              style={{ width: 100, height: 60, objectFit: 'cover', borderRadius: '4px' }}
                            />
                          ) : (
                            'No Image'
                          )}
                        </TableCell>
                        <TableCell>
                          <IconButton color="primary" onClick={() => handleEdit(news)}>
                            <EditIcon />
                          </IconButton>
                          <IconButton color="error" onClick={() => handleDelete(news._id)}>
                            <DeleteIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Container>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="h2" gutterBottom sx={{ mt: 20 }}>
            {message}
          </Typography>
        </Box>
      )}
    </AdminLayout>
  );
};

export default UpdateNews;
